import { ConnectionBar, Page } from '@nx/ui';

import ConnectionMethodSelector from './connection-method-selector';
import Content from './content';
import Header from './header';
import Resources from './resources';
import Tools from './tools';

export const DeveloperHub = () => {
  return (
    <div className="h-full w-full">
      <ConnectionBar />
      <Page contentType="extra-light" className="@container flex flex-col gap-6">
        <Header />
        <div className="flex flex-col gap-8">
          <ConnectionMethodSelector />
          <Content />
          <Tools />
          <Resources />
        </div>
      </Page>
    </div>
  );
};
